import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user: any = {};
  restaurantId:any;
  
  

  constructor(private router: Router) {
  }

  isLoggedIn(): boolean {
    return this.getToken() ? true : false;
  }

  setToken(token: any) {
    localStorage.setItem('token', token);
  }

  getToken() {
    return localStorage.getItem('token');
  }

  clearToken() {
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }

  

  setUser(user: any) {
    console.log("user",user)
    this.user = user;
    console.log(user?.contact?.type)
    this.getRole();
  }

 
  getUser() {
    return this.user;
  }

  setRestaurantId(restId: any){
    localStorage.setItem('restaurantId', restId);
   // this.restaurantId=restId;
  }

  getRestaurantId() {
    //return this.restaurantId;
    return localStorage.getItem('restaurantId');
  }


  getRoleName = new Subject<any>();


 
  getRole() {
    let roleName = this.user?.roleMaster
      ? this.user?.contact?.type
      : '';
    this.getRoleName.next(roleName);
    // this.getRole$.next(roleName)
  }

  public isAuthorized(allowedRoles: string[],role:string): boolean {
    // const role = this.currentRoleValue;
    console.log("role:",role);
    return allowedRoles.includes(role);
  }
  
}
